import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62')
];

export const server_loads = [0,2,3,5,7,9,10,12];

export const dictionary = {
		"/(pages)/[[lang]]/alle-avtaler": [~15,[2]],
		"/(pages)/[[lang]]/avtale": [~16,[2,3]],
		"/(pages)/[[lang]]/avtale/avtalespot": [~17,[2,3]],
		"/(pages)/[[lang]]/avtale/boligselskap": [~18,[2,3]],
		"/(pages)/[[lang]]/avtale/bonord": [~19,[2,3]],
		"/(pages)/[[lang]]/avtale/bospot-ansatt": [~20,[2,3,4]],
		"/(pages)/[[lang]]/avtale/bospot-ansatt/nord": [~21,[2,3,4]],
		"/(pages)/[[lang]]/avtale/fastpris": [~22,[2,3]],
		"/(pages)/[[lang]]/avtale/fordelsspot-nord": [~23,[2,3]],
		"/(pages)/[[lang]]/avtale/fordelsspot-sor": [~24,[2,3]],
		"/(pages)/[[lang]]/avtale/ishavsspot": [~25,[2,3]],
		"/(pages)/[[lang]]/avtale/landbruk": [~26,[2,3]],
		"/(pages)/[[lang]]/avtale/pbl": [~27,[2,3]],
		"/(pages)/[[lang]]/avtale/plusskunde": [~28,[2,3]],
		"/(pages)/[[lang]]/avtale/seniorstrom": [~29,[2,3]],
		"/(pages)/[[lang]]/avtale/sit": [30,[2,3,5]],
		"/(pages)/[[lang]]/avtale/strawberry-ansatt": [~32,[2,3]],
		"/(pages)/[[lang]]/avtale/strawberry": [~31,[2,3]],
		"/(pages)/[[lang]]/design": [33,[2]],
		"/(pages)/[[lang]]/design/2023": [34,[6]],
		"/(pages)/[[lang]]/design/knapper": [35,[2]],
		"/(pages)/[[lang]]/hoiax": [~36,[2]],
		"/(pages)/[[lang]]/nettbutikk": [~37,[2,7]],
		"/(pages)/[[lang]]/nettbutikk/kategori/[category]": [~40,[2,7]],
		"/(pages)/[[lang]]/nettbutikk/kategori/[category]/kjopsbetingelser": [~41,[2,7]],
		"/(pages)/[[lang]]/nettbutikk/kategori/[category]/standard-installasjon": [~42,[2,7]],
		"/(pages)/[[lang]]/nettbutikk/[product]": [~38,[2]],
		"/(pages)/[[lang]]/nettbutikk/[product]/bestill": [~39,[2]],
		"/(pages)/[[lang]]/norgespris": [~43,[2]],
		"/(pages)/[[lang]]/om/aktuelt/(lists)": [~44,[2,8]],
		"/(pages)/[[lang]]/om/aktuelt/(lists)/sparetips": [~45,[2,8]],
		"/(pages)/[[lang]]/om/aktuelt/[slug]": [46,[2,9]],
		"/(pages)/[[lang]]/om/personvern": [~47,[2]],
		"/(pages)/[[lang]]/om/personvern/cookies": [48,[2]],
		"/(pages)/[[lang]]/privat/avtalevilkar-for-levering-av-kraft": [~49,[2]],
		"/(pages)/[[lang]]/privat/dagens-strompris": [50,[2,10]],
		"/(pages)/[[lang]]/privat/dagens-strompris/tabell": [51,[2,10]],
		"/(pages)/[[lang]]/privat/dagens-strompris/timespris/[[area]]": [52,[2,10,11]],
		"/(pages)/[[lang]]/privat/hva-koster": [53,[2,12]],
		"/(pages)/[[lang]]/privat/kundeservice": [~54,[2]],
		"/(pages)/[[lang]]/privat/samarbeidspartnere": [~55,[2]],
		"/(pages)/[[lang]]/privat/skjema": [~56,[2]],
		"/(pages)/[[lang]]/privat/skjema/avslutte-avtale": [57,[2]],
		"/(pages)/[[lang]]/privat/skjema/move-to-new-address": [58,[2]],
		"/(pages)/[[lang]]/privat/smartlading": [~59,[2]],
		"/(pages)/[[lang]]/privat/stromanalyse": [~60,[2]],
		"/(pages)/[[lang]]/sok": [61,[2]],
		"/(pages)/[[lang]]/sporsmal-svar/[...slug]": [~62,[2]],
		"/(pages)/[[lang]]/[slug]": [~14,[2]],
		"/(pages)/[[lang]]": [~13,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';